module.exports = __webpack_public_path__ + "img/Feature.eacb54e8.png";